import { TRoomsParams } from '../../../common/types/floor-params.type';
import { RoomType } from '../types';

export const getRoomTypeTitle = (room: TRoomsParams) => {
  switch (room.roomType) {
    case RoomType.KITCHEN:
      return 'Кухня';
    case RoomType.BATHROOM:
      return 'Ванная';
    case RoomType.LIVING_ROOM:
      return 'Гостиная';
    case RoomType.BEDROOM:
      return 'Спальня';
    case RoomType.HALLWAY:
      return 'Прихожая';
    case RoomType.NURSERY:
      return 'Детская';
    case RoomType.OFFICE_SPACE:
      return 'Офис';
    default:
      return 'Комната';
  }
};
